import { useQuery } from '@tanstack/react-query';
import apiService from '../../services/api';
import { queryKeys } from '../../api/queryKeys';
import { buildApiUrl } from '../../utils/apiUrl';

const CORE_STALE_MS = 5 * 60 * 1000;

function shouldLogQueryError(error) {
  return error?.status !== 401 && error?.status !== 429;
}

export function useStreamConfigQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.core.streamConfig,
    queryFn: () => apiService.getStreamConfig(),
    staleTime: CORE_STALE_MS,
    ...options,
  });
}

export function useFeaturedContentQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.core.featuredContent,
    queryFn: () => apiService.getFeaturedContent(),
    staleTime: CORE_STALE_MS,
    ...options,
  });
}

export async function fetchMaintenanceStatus() {
  const response = await fetch(buildApiUrl('/api/core/maintenance-status/'), {
    headers: { 'Content-Type': 'application/json' },
  });
  if (!response.ok) {
    const err = new Error(`maintenance-status ${response.status}`);
    err.status = response.status;
    throw err;
  }
  return response.json();
}

/** Public maintenance flag — polled on `/maintenance` and AppLayout guard. */
export function useMaintenanceStatusQuery(options = {}) {
  const { refetchInterval, ...rest } = options;
  return useQuery({
    queryKey: queryKeys.core.maintenanceStatus,
    queryFn: fetchMaintenanceStatus,
    staleTime: 30 * 1000,
    refetchInterval: refetchInterval ?? false,
    ...rest,
  });
}

export { shouldLogQueryError };
